import { useMemo } from 'react'

export const useSumTotalValue = (array: any[] | undefined, key: string): number => {
  const totalValue: number = useMemo(
    () => array?.reduce((previous, current) => previous + (current[key] || 0), 0),
    [array, key],
  )

  if (!array?.length) return 0

  return totalValue
}
